import axiosClient from 'api/config/axiosClient';

const getTrackingCode = ({ pageNumber, pageSize, isAll }) => {
  const url = `v1/tracking-code?pageNumber=${pageNumber}&pageSize=${pageSize}&isAll=${isAll}`;
  return axiosClient.get(url);
};

const getDetailTrackingCode = ({ trackingCodeId }) => {
  const url = `v1/tracking-code/${trackingCodeId}`;
  return axiosClient.get(url);
};

const registerTrackingCode = (payload) => {
  const url = 'v1/tracking-code';
  return axiosClient.post(url, payload);
};

const editTrackingCode = ({ trackingCodeId, payload }) => {
  const url = `v1/tracking-code/${trackingCodeId}`;
  return axiosClient.put(url, payload);
};

const deleteTrackingCode = (payload) => {
  const url = 'v1/tracking-code/delete';
  return axiosClient.delete(url, { data: payload });
};

export {
  getTrackingCode,
  getDetailTrackingCode,
  registerTrackingCode,
  editTrackingCode,
  deleteTrackingCode,
};
